import type { Components, Theme } from "@mui/material/styles";

export const MuiStack: NonNullable<Components<Theme>["MuiStack"]> = {
  defaultProps: { useFlexGap: true },
};
